import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoof = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_1",
	xmlns: "http://www.w3.org/2000/svg",
	width: 90,
	height: 90,
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 59.25,
			y: 14.09,
			width: 15,
			height: 10,
			transform: "translate(27.03 76.04) rotate(-71.07)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 80.76,
			y: 33.09,
			width: 15,
			height: 10,
			transform: "translate(-7.76 42.65) rotate(-26.06)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 13.39,
			y: 66.04,
			width: 15,
			height: 10,
			transform: "translate(-29.09 16.4) rotate(-26.06)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 14.11,
			y: 34.9,
			width: 10,
			height: 15,
			transform: "translate(-27.2 46.71) rotate(-71.07)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 33.1,
			y: 13.38,
			width: 10,
			height: 15,
			transform: "translate(-5.3 18.86) rotate(-26.06)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00488E",
			className: "cls-1",
			d: "M148.09,55H79.95c.01-.34,.04-.67,.04-1.01,0-14.5-10.12-24.62-24.62-24.62s-24.62,10.12-24.62,24.62c0,9.26,4.11,16.88,11.15,21.1l-21.9,43.98v60.93H180v-61.18l-31.91-63.82Zm-36.49,60.01l-18.78,.05,5.03-10.06h18.8l-5.06,10.01Zm-28.51-40.01l5-10h18.58l-5,10h-18.58Zm13.58,10l-5,10h-18.58l5-10h18.58Zm-24.76-10h-18.79l4.98-10h18.81l-5,10Zm-23.77,10h18.77l-5,10h-18.75l4.98-10Zm8.77,20l-5.08,10.17-18.74,.05,5.09-10.22h18.73Zm11.18,0h18.58l-5.04,10.09-18.6,.05,5.07-10.14Zm53.62-10h-18.86l5-10h18.91l-5.05,10Zm10.11-20h-18.97l5-10h19.02l-5.05,10ZM40.75,53.99c0-9.02,5.6-14.62,14.62-14.62s14.62,5.6,14.62,14.62c0,.34-.03,.67-.04,1.01h-18.04l-5.52,11.09c-3.62-2.51-5.63-6.77-5.63-12.1Zm-10.75,71.24l79.47-.21,.47,44.99H30v-44.77Zm140,44.77h-50.05l-.51-48.34,25.54-50.53,25.02,50.05v48.82Z"
		})
	]
});
export default SvgRoof;
